
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { AppModule } from '@/store/modules/app'
import productOptionMixin from '@/mixin/productOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import {
  getAccountGroupList,
  editAccountGroupList,
  delAccountGroup
} from '@/api/product/accountGroup'
import pagination from '@/components/Pagination/index.vue'
import addAccountGroup from './components/addAccountGroup.vue'
import editAccountGroup from './components/editAccountGroup.vue'
import { getProduct, setProduct } from '@/utils/cookies'

@Component({
  name: 'accountGroup',
  components: { pagination, addAccountGroup, editAccountGroup }
})
export default class extends mixins(productOptionMixin, currencyOptionMixin) {
  queryForm = {
    currency: AppModule.currentCurrencyType,
    name: '',
    product: '',
    status: null
  }
  private currentProduct: any = { id: '' } // 当前选中的产品对象
  private currentId: any = ''
  private listLoading: boolean = false
  private accountGroupList: any = []
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private dialogVisible: boolean = false
  private editVisible: boolean = false
  private action: string = ''
  private accountGroupId: string | null = null
  private productNameList: string[] = []
  get language() {
    return AppModule.language
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const params = {
        ...this.queryForm,
        product: this.currentProduct.id,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getAccountGroupList(params).then((res: any) => {
        this.total = res.count
        this.accountGroupList = res.results
        this.listLoading = false
      })
    } catch (e) {}
  }

  @Watch('onProductList')
  watchArr() {
    let product: any = getProduct()
    let arr: any = this.onProductList.filter((item: any) => {
      return item.id === product - 0
    })
    if (arr.length > 0) {
      this.currentProduct = arr[0]
      this.currentId = arr[0].id
    } else {
      setProduct(this.onProductList[0].id)
      this.currentId = this.onProductList[0].id
      this.currentProduct = this.onProductList[0]
    }
    this.hadleGetFilesListApi()
  }

  // 货币切换
  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  // 产品切换
  private async selProduct() {
    this.accountGroupList = []
    setProduct(this.currentId)
    let arr: any = this.onProductList.filter((item: any) => {
      return item.id === this.currentId - 0
    })
    if (arr.length > 0) {
      this.currentProduct = arr[0]
    }
    this.reset()
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  // 重置查询
  private reset() {
    this.queryForm.name = ''
    this.queryForm.status = null
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  // 编辑账户组状态
  private async setStatus(row) {
    // 保存原来的状态
    const status = row.status === 0 ? 1 : 0
    const data: any = {
      id: row.id,
      status: row.status
    }
    try {
      await editAccountGroupList(data).then(() => {
        this.$message({
          message: 'Save Successful!',
          type: 'success'
        })
        this.hadleGetFilesListApi()
      })
    } catch (e) {
      row.status = status
    }
  }

  // 打开创建
  private openDialogVisible(action: string) {
    this.action = action
    this.dialogVisible = true
  }
  // 关闭创建
  private closeDialogVisible() {
    this.dialogVisible = false
    this.hadleGetFilesListApi()
  }

  // 打开编辑
  private async openEdit(id: string | null) {
    this.accountGroupId = id
    this.editVisible = true
  }

  // 关闭编辑
  private editCloseDialog() {
    this.editVisible = false
    this.hadleGetFilesListApi()
  }

  // 删除账户组
  private del(id: number) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          const data: any = {
            id: id
          }
          if (action === 'confirm') {
            delAccountGroup(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.hadleGetFilesListApi()
            })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          const data: any = {
            id: id
          }
          if (action === 'confirm') {
            delAccountGroup(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.hadleGetFilesListApi()
            })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          const data: any = {
            id: id
          }
          if (action === 'confirm') {
            delAccountGroup(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.hadleGetFilesListApi()
            })
          }
        }
      })
    }
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.accountGroup`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
